"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InflationController__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "PER_BILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_MILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PER_TRILL",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "ZERO_ADDRESS",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inflationDestination",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inflationRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISettings",
                name: "_settings",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_inflationRate",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "_inflationDestination",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "lastInflationTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mintInflatedTokens",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_destination",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "mintSQT",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_inflationDestination",
                type: "address",
            },
        ],
        name: "setInflationDestination",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_inflationRate",
                type: "uint256",
            },
        ],
        name: "setInflationRate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "settings",
        outputs: [
            {
                internalType: "contract ISettings",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class InflationController__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "InflationController";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.InflationController__factory = InflationController__factory;
InflationController__factory.bytecode = _bytecode;
InflationController__factory.abi = _abi;
